import { DELIMITER } from "./delimiter";
export default {
    [DELIMITER.TAB]: "\t",
    [DELIMITER.COMMA]: ",",
    [DELIMITER.SEMICOLON]: ";",
    [DELIMITER.SPACE]: " "
};
